"use client";

import { useState } from "react";
import { css } from "styled-system/css";
import { Plus } from "lucide-react";

const LANDING_DISPLAY = '"Spectral", ui-serif, Georgia, serif';
const EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

export function LandingFaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={css({ borderBottomWidth: "1px", borderColor: "#e7ebf0" })}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={css({
          width: "100%",
          textAlign: "left",
          py: "5",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "4",
          bg: "transparent",
          border: "none",
          cursor: "pointer",
          px: "0",
        })}
        aria-expanded={open}
      >
        <span
          style={{ fontFamily: LANDING_DISPLAY, fontWeight: 600, fontSize: 19, color: "#111827" }}
          className={css({ lineHeight: "snug", pr: "2" })}
        >
          {q}
        </span>
        <Plus
          size={20}
          strokeWidth={2}
          className={css({ flexShrink: 0, color: "#4f46e5" })}
          style={{
            transition: `transform 0.3s ${EASE}`,
            transform: open ? "rotate(135deg)" : "rotate(0deg)",
          }}
          aria-hidden
        />
      </button>

      <div
        className={css({ display: "grid", overflow: "hidden" })}
        style={{
          gridTemplateRows: open ? "1fr" : "0fr",
          transition: `grid-template-rows 0.28s ${EASE}`,
        }}
      >
        <div className={css({ minH: 0, overflow: "hidden" })}>
          <p
            className={css({
              pb: "5",
              color: "#51607a",
              lineHeight: "1.65",
              fontSize: "15px",
              maxW: "46ch",
              m: 0,
            })}
          >
            {a}
          </p>
        </div>
      </div>
    </div>
  );
}
